module.exports = __webpack_public_path__ + "media/4.e8118592.mp3";